import React from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import PlanCard from "../../components/PlanCard";
import StaticDataPanel from "../../components/plans/StaticDataPanel";

/*
    API PLANS.

    Three subscribable tiers in a grid, then the one-time Static Data purchase
    in its own panel underneath — the slot the Enterprise API block used to
    occupy. That block is gone, along with the "Try our sample course for
    Free" button that used to sit under the heading: the Sample Course tier is
    now a card on the grid with its own "Try it out", and two buttons to the
    same checkout is one more than the page needs.

    The page footnote is gone with them. It explained two asterisks: the "**"
    beside the Static Data price, which is now stated in full inside the Static
    Data panel next to the price it qualifies; and the "*" on response times,
    which the new feature lists do not mention at all. A footnote explaining
    marks that no longer appear is just noise.
*/
const PlansPricing = () => {
  const { user } = useSelector((state) => state.authUser);

  // Someone already on a plan is choosing between plans, not starting out.
  const hasPlan = user?.api_plan === "test" || user?.stripe_customer_id;

  return (
    <div className="plans-page">
      <Row className="w-100 m-0">
        <Col className="pt-5 pb-1" sm="12">
          <div className="plans-page__intro">
            <h1 className="fs--38 fw--700 font-poppins py-3">API Plans</h1>
            <p className="fs--18 fw--400 font-poppins">
              {hasPlan
                ? "Need full access to the API? Switch your plan below."
                : "Get started today with a free trial or sign up for a paid plan."}
            </p>
          </div>
        </Col>
      </Row>

      <Row className="w-100 m-0 pb-5">
        <Col sm="12" className="px-lg-narrow px-wide">
          <div className="plans-page__grid-wrap">
            <PlanCard />
          </div>
        </Col>

        <Col sm="12" className="w-100 m-0 py-5 px-lg-narrow px-wide">
          <StaticDataPanel />
        </Col>
      </Row>
    </div>
  );
};

export default PlansPricing;
